module.exports = __webpack_public_path__ + "assets_app/img/key-2.455b36d8.svg";